import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {WebsocketEnums} from '../../enums/websocket-enums';


@Injectable({
  providedIn: 'root'
})
export class WebsocketsHelperService {
  notificationReceivedSubject = new Subject();
  supportNotificationReceivedSubject = new Subject();
  giftsNotificationReceivedSubject = new Subject();

  private getEchoInstance(): any {
    return (window as any)?.Echo;
  }

  listenToNotifications(userId: number): void {
    const channelName = WebsocketEnums.notificationsChannelName + userId;
    const echoInstance = this.getEchoInstance();
    if (!echoInstance) {
      return;
    }
    const channel = (window as any).Echo.private(channelName);
    channel.notification((e: any) => {
      this.notificationReceivedSubject.next(e);
    });
    channel.listen(WebsocketEnums.supportNotificationsChannelEvent, (e: any) => {
      this.supportNotificationReceivedSubject.next(e);
    });
  }

  disconnectFromNotificationsChannel(userId: number): void {
    const echoInstance = this.getEchoInstance();
    if (!echoInstance) {
      return;
    }
    echoInstance.leave(WebsocketEnums.notificationsChannelName + userId);
  }
}

